import script from "./CadastroSetor.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroSetor.vue?vue&type=script&setup=true&lang=js"

import "./CadastroSetor.vue?vue&type=style&index=0&id=8dcff98c&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dcff98c"]])

export default __exports__